module.exports = __webpack_public_path__ + "static/media/sdf.9c5cf117.png";